import { Types } from "../actions/favoritos";

export default function favoritosReducer(
  state = {
    productosFavoritos: {},
    loading: false,
    success: false,
    error: false,
    esFavorito: false,
  },
  action,
) {
  switch (action.type) {
    case Types.FAVORITOS_GET_REQUEST:
      return { ...state, loading: true };
    case Types.FAVORITOS_GET_SUCCEEDED:
      return {
        ...state,
        productosFavoritos: action.productosFavoritos,
        loading: false,
        success: true,
        error: false,
      };
    case Types.FAVORITOS_GET_ERROR:
      return { ...state, loading: false, success: false, error: action.err };

    case Types.FAVORITOS_AGREGAR_REQUEST:
      return { ...state, loading: true };
    case Types.FAVORITOS_AGREGAR_SUCCEEDED:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
      };
    case Types.FAVORITOS_AGREGAR_ERROR:
      return { ...state, loading: false, success: false, error: action.err };

    case Types.FAVORITOS_ELIMINAR_REQUEST:
      return { ...state, loading: true };
    case Types.FAVORITOS_ELIMINAR_SUCCEEDED:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
      };
    case Types.FAVORITOS_ELIMINAR_ERROR:

    case Types.FAVORITOS_ES_FAVORITO_REQUEST:
      return { ...state, loading: true };
    case Types.FAVORITOS_ES_FAVORITO_SUCCEEDED:
      return { ...state, esFavorito: action.esFavorito, loading: false };
    case Types.FAVORITOS_ES_FAVORITO_ERROR:
      return { ...state, loading: false, success: false, error: action.err };
    default:
      return state;
  }
}
